    <template>
    <a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-7">
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input label="Group By" >
                                        <select class="form-control" size="large" v-model="inputGroupBy" @click.prevent="autoChange">
                                            <option v-for="option in groupOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                {{ option.value }}
                                            </option>
                                        </select>
                                    </base-input>
                                </div>
                            </div>
        
                            <div v-if="inputGroupBy == 'monthly'" class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="From"><br>
                                        <a-month-picker v-model="inputFrom" placeholder="Select month" style="width:100%" :format="monthFormat"/>
                                    </base-input>
                                </div>
        
                                <div class="col-md-7">
                                    <base-input alternative="" label="To"><br>
                                        <a-month-picker v-model="inputTo" placeholder="Select month" style="width:100%" :format="monthFormat"/>
                                    </base-input>
                                </div>
                            </div>
                            <div v-else class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="From"><br>
                                        <a-range-picker v-model="inputDate" :showTime="{ format: 'hh:mm' }" format="MM-DD-YYYY hh:mm A" :placeholder="['Start Date', 'End Date']" style="width:100%"/>
                                    </base-input>
                                </div>
                            </div>
                            <div class="row" v-if="site_type == 'ho'">
                                    <div class="col-md-7">
                                        <base-input label="Location">
                                            <a-cascader v-model="inputLocation" :options="locationOptions" @change="onLocationChange" placeholder="All Locations" style="width: 100%" changeOnSelect/>
                                        </base-input>
                                    </div>
                                </div>
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="Select Site">
                                        <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                            <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input label="Sort By" >
                                        <select class="form-control" size="large" v-model="inputSortBy" @click.prevent="sortChange">>
                                            <option v-for="option in sortOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                {{ option.value }}
                                            </option>
                                        </select>
                                    </base-input>
                                </div>
                                <div class="col-md-2 mt-3 pt-3">
                                    <button type="button" class="btn btn-sm btn-link" @click='showSortInfoDiv' >
                                        {{showSortInfo == 'asc' ? 'Ascending (A-Z) ↡' : 'Descending (Z-A) ↟'}}
                                    </button>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-2">
                                    <base-checkbox class="mb-3" v-model="isSeparateSite">
                                        Separate per site
                                    </base-checkbox>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <button class="btn btn-sm" style="background-color: #394A5D; color: white;" @click.prevent="advanceFilter(true)">
                                        {{toggleLabel}}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 align-self-center">
                            <div v-if="reportDescription != ''" class="card">
                                <div class="card-body">
                                    <div class="card-text">
                                        {{ reportDescription }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                            <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;

                            <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '_')">
                                <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;"> Download CSV </button> &nbsp; &nbsp;
                            </vue-json-to-csv>
                            <button v-if="JsonData.length > 0" class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%%;" @click.prevent="generateExcel"> Download excel </button> &nbsp; &nbsp;
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="toggleAdvanceFilter" id="hide" class="col-md-12">
            <a-drawer title="" width="500" placement="right" @close="closeFilter" :visible="advancedFilterVisible">
                <advance-filter :parentParams="advancedFilterParams" @changeParams="changeParams" @closeFilter="closeFilter"></advance-filter>
            </a-drawer>
        </div>
    </div>
    </a-spin>
    </template>

    <script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import AdvanceFilter from '../Bir Reports/ReportAdvanceFilter'
    import reportUtils from '../../components/reportUtils'
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import VueJsonToCsv from 'vue-json-to-csv';
    import * as ExcelJS from "exceljs";
    import { saveAs } from "file-saver";

    import {
        mapState,
        mapActions
    } from 'vuex'
    import { getReportDescription } from '../../utilities';

    var component_x;

    export default {
        components: {
            AdvanceFilter,VueJsonToCsv
        },
        data() {
            return {
                spinning: false,
                inputDate: [moment().startOf('day'), moment().endOf('day')],
                inputGroupBy: '',
                groupOptions: [
                    {key: '', value: 'No Grouping'},
                    {key: 'supplier_id', value: 'Supplier'},
                    {key: 'supplier_type_id', value: 'Supplier Type, Supplier'},
                    {key: 'brand_id', value: 'Brand'},
                    {key: 'division_id', value: 'Division'},
                    {key: 'department_id', value: 'Department'},
                    {key: 'section_id', value: 'Section'},
                    {key: 'category_id', value: 'Category'},
                    {key: 'customer_id', value: 'Customer'},
                    {key: 'customer_type_id', value: 'Customer Type'},
                    {key: 'salesman_id', value: 'Salesman'}
                ],
                inputSite: [],
                site_type: "ho",
                siteOptions: [],
                inputLocation: [],
                locationOptions: [],
                headerExcelInfo: "",
                isShowTotalAmountWithoutTax: false,
                isShowSalesmanComm: false,

                inputSortBy: 'id',
                sortOptions: [
                    {key: 'id', value: 'Product Code'},
                    {key: 'barcode', value: 'Barcode'},
                    {key: 'name', value: 'Name or Description'},
                    {key: 'total_amount', value: 'Total Amount'},
                    {key: 'qty', value: 'Total Quantity'}
                ],
                currDate: moment().format("L_LT").split(":").join(";"),
                isSeparateSite: true,
                isShowDetail: true,
                isShowReferenceCode: false,
                inputFrom: moment().startOf('month'),
                inputTo: moment().endOf('month'),
                monthFormat: 'MM/YYYY',
                birSalesReports: [],
                toggleAdvanceFilter: false,
                toggleLabel: "Advanced Filter",
                advancedFilterParams: {},
                params: {},
                advancedFilterVisible: true,

                showSortInfo: 'asc',
                inputShowTop: 0,
                JsonData: [],
                accessRights:[],
                reportDescription: ''
            }
        },
        mounted: async function () {
            component_x = this;

            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            if(component_x.categoriesOptions.length == 0){
                var options = await HTTPRequest.getRequest(this.endPoint + 'categories/cascader_view', null);
                component_x.updateCategoriesOptions(options)
            }

            this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null)

            let siteId = secureStorage.getItem("defaultSiteId")
            this.inputSite = [siteId]
            

            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }
            this.reportDescription = await getReportDescription(this.currentProfile)
            this.accessRights = this.$attrs.access_rights || []
        },
        computed: {
            ...mapState(['currentProfile', 'endPoint', 'categoriesOptions']),
        },
        watch: {
            inputLocation: {
                handler: 'handleInputLocationChange',
                deep: true
            }
        },
        methods: {
            ...mapActions(['updateCategoriesOptions']),
            moment,
            async onLocationChange(){
                this.siteOptions = await HTTPRequest.getRequest(component_x.endPoint + 'sites/get_valid_sites?location_id=' + this.inputLocation[this.inputLocation.length - 1], null)
                this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null);
                this.inputSite = this.siteOptions.map( s => s.id);
            },
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            // Advanced Info
            showSortInfoDiv(){
                this.showSortInfo == 'asc' ? this.showSortInfo = 'desc' : this.showSortInfo = 'asc'
            },
            autoChange(e){
                if(e.target.value == ''){
                    this.isShowDetail = true
                }
            },
            sortChange(e){
                if(e.target.value != 'total_amount' || e.target.value != 'qty'){
                    this.inputShowTop = 0
                }
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            convertToCurrency(num){
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            advanceFilter(value){
                this.toggleAdvanceFilter = value
                if(this.toggleAdvanceFilter == true){
                    this.toggleLabel = "Collapse Filter"
                }else{
                    this.toggleLabel = "Advanced Filter"
                }
            },
            closeFilter(){
                this.advanceFilter(false)
            },
            changeParams(params, actualParams, mode){
                this.params = params
                this.advancedFilterParams = actualParams

                if(mode == 'filter'){
                    this.advanceFilter(false);
                }
            },
            async handleInputLocationChange(newVal, oldVal) {
                if (!newVal || newVal.length === 0) {
                    var userId = secureStorage.getItem("userId");
                    var sites = await HTTPRequest.getRequest(this.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
                    this.siteOptions = sites;
                    this.sort(this.siteOptions);
                    this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null)
                    let siteId = secureStorage.getItem("defaultSiteId");
                    this.inputSite = [siteId]
                }
            },
            generateReport: async function () {
                this.spinning= true;
                let {from_date, to_date, from_header, to_header} = reportUtils.buildFromToHeaders(component_x, this.inputGroupBy, this.inputDate)
                let {filter_header, additional_params, status_header} = reportUtils.advanceFilterTools.buildAdditionalParams(this.params,this.advancedFilterParams, this.inputLocation)
                let parameters = {
                    "site_id": this.inputSite.toString(),
                    "date_from": from_date,
                    "date_to": to_date,
                    "group": this.inputGroupBy,
                    "isShow": this.isShowDetail,
                    "order": this.inputSortBy,
                    "by": this.showSortInfo,
                    "top": this.inputShowTop,
                    "isSeparate": this.isSeparateSite,
                    ...((this.inputLocation.length > 0) && {"location_path": this.inputLocation.toString()}),
                    "advanced_filter": this.params
                }

                var get_request = await HTTPRequest.getRequest(this.endPoint + 'detailed_discount_reports?', parameters);
                if(get_request.error) {
                    reportUtils.openNotificationWithIcon(component_x, 'error', get_request.error);
                    return
                }

                var siteSpecific = get_request;
                let design_x = 0
                let design_y = 0

                if(siteSpecific.length > 0){
                    var doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'b3' });

                    let reportLogo = document.getElementById('reportLogo');
                    doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);

                    let headers = [];

                    headers = [
                        [
                            {content: 'Date', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            {content: 'Trans Id', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            {content: 'Site', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            {content: 'Terminal Id', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            {content: 'SI #', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            {content: 'Product Code', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            {content: 'Barcode', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            {content: 'Description', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            {content: 'Quantity', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            {content: 'Discount Rate', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            {content: 'Approver', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            {content: 'Promo', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            {content: 'Manual Discount', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            {content: 'SC', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            {content: 'PWD', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            {content: 'Total Discount', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            {content: 'SRP', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            {content: 'Subtotal', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            {content: 'Vatable Sales', styles: {width: 'auto',halign: 'center', valign: 'auto'}}
                        ]
                    ]

                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details

                        let total_qty = 0
                        let total_total_amount = 0
                        let grand_qty = 0
                        let grand_total_amount = 0

                        if(x > 0 && this.birSalesReports.length > 0){
                            doc.addPage();
                        }

                        let reportData = [];
                        let grouper = 'start'
                        let type_header = 'start'

                        if(this.birSalesReports.length > 0){
                            let monthly_grouper_arr = []
                            let arr = 'start'

                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]

                                let grouper_name = reportLine.grouper_name
                                if(this.inputGroupBy == 'supplier_type_id'){
                                    if(type_header == 'start'){
                                        let type_header = [{content: reportLine.header_name, colSpan: 2, styles: {halign: 'left', fontStyle: 'bold'}}]
                                        reportData.push(Object.assign({}, type_header))
                                    } else {
                                        if(type_header != reportLine.header_id){
                                            let type_header = [{content: reportLine.header_name, colSpan: 2, styles: {halign: 'left', fontStyle: 'bold'}}]
                                            reportData.push(Object.assign({}, type_header))
                                        }
                                    }
                                    type_header = reportLine.header_id
                                }

                                if(this.inputGroupBy != ''){
                                    if(this.isShowDetail == true){
                                        if(grouper == 'start'){
                                            let detail_header = [{content: grouper_name, colSpan: 2, styles: {halign: 'left', fontStyle: 'bold'}}];
                                            reportData.push(Object.assign({}, detail_header))
                                        } else {
                                            if(grouper != reportLine.grouper_id){
                                                let detail_header = [{content: grouper_name, colSpan: 2, styles: {halign: 'left', fontStyle: 'bold'}}];
                                                reportData.push(Object.assign({}, detail_header))
                                            }
                                        }
                                        grouper = reportLine.grouper_id
                                    }
                                }

                                let detail = []
                                detail = [
                                    reportLine.document_date,
                                    reportLine.trans_id,
                                    reportLine.site_name,
                                    reportLine.terminal_id,
                                    reportLine.invoice_no,
                                    reportLine.product_code,
                                    reportLine.barcode,
                                    reportLine.description,
                                    this.convertToCurrency(Number(reportLine.quantity)),
                                    reportLine.discount_rate,
                                    reportLine.approver,
                                    this.convertToCurrency(Number(reportLine.promo_price)),
                                    this.convertToCurrency(Number(reportLine.manual_discount)),
                                    this.convertToCurrency(Number(reportLine.senior_discount)),
                                    this.convertToCurrency(Number(reportLine.pwd_discount)),
                                    this.convertToCurrency(Number(reportLine.overall_discount)),
                                    this.convertToCurrency(Number(reportLine.price)),
                                    this.convertToCurrency(Number(reportLine.total_amount)),
                                    this.convertToCurrency(Number(reportLine.vat_sales))
                                ]

                                reportData.push(Object.assign({}, detail))

                                total_qty += Number(reportLine.quantity)
                                total_total_amount += Number(reportLine.total_amount)

                                grand_qty += Number(reportLine.quantity)
                                grand_total_amount += Number(reportLine.total_amount)

                                if(i == this.birSalesReports.length-1){
                                    if(this.inputGroupBy != ''){
                                        let sub_detail = []

                                        let spacer = grouper_name
                                        if(this.inputGroupBy == 'supplier_type_id'){
                                            spacer = reportLine.header_name
                                        }

                                        sub_detail = ["", "", "","","","",
                                            {content: spacer, styles: {halign: 'right', fontStyle: 'bold'}}, "",
                                            this.convertToCurrency(total_qty), '','','','','','','',
                                            this.convertToCurrency(total_total_amount)
                                        ]
                                        reportData.push(Object.assign({}, ["rowLine"]))
                                        reportData.push(Object.assign({}, sub_detail))
                                    
                                    }

                                    reportData.push(Object.assign({}, ["rowLine"]))

                                    reportData.push(Object.assign({}, ["", "", "","","","", 'Grand Total :', '',
                                        this.convertToCurrency(grand_qty), '','','','','','','',
                                        this.convertToCurrency(grand_total_amount)
                                    ]));

                                } else {

                                    let current_grouper = ""
                                    let next_grouper = ""
                                    if(this.inputGroupBy == 'supplier_type_id'){
                                        current_grouper = reportLine.header_id
                                        next_grouper = this.birSalesReports[i+1].header_id
                                    } else {
                                        current_grouper = reportLine.grouper_id
                                        next_grouper = this.birSalesReports[i+1].grouper_id
                                    }

                                    if(current_grouper != next_grouper){
                                        if(this.inputGroupBy != ''){
                                            reportData.push(Object.assign({}, ["rowLine"]))
                                            let sub_detail = []

                                            let spacer = grouper_name
                                            if(this.inputGroupBy == 'supplier_type_id'){
                                                spacer = reportLine.header_name
                                            }

                                            sub_detail = ["", "", "","","","",
                                                {content: spacer, styles: {halign: 'right', fontStyle: 'bold'}}, "",
                                                this.convertToCurrency(total_qty), '','','','','','','',
                                                this.convertToCurrency(total_total_amount)
                                            ]

                                            reportData.push(Object.assign({}, sub_detail))

                                            total_qty = 0
                                            total_total_amount = 0
                                        }
                                    }
                                
                                }
                            }
                        }

                        let group_text = ""
                        if(this.inputGroupBy != ''){
                            group_text = " by " + this.groupOptions.find(x => x.key === this.inputGroupBy).value
                        }

                        design_x = 330
                        design_y = 200

                        doc.setFontSize(14);
                        doc.setFontType("bold");
                        doc.text(15,20,"Detailed Discount Report" + group_text)
                        doc.setFontType("normal");
                        doc.setFontSize(10);
                        if(this.isSeparateSite == true){
                            doc.text(450,20,siteSpecific[x].report_details[0].site_name,"right");
                        } else {
                            let site_text = ''
                            if(this.inputSite.length == 0){
                                site_text = 'All Sites'
                            } else {
                                let sites = this.inputSite
                                for (var s = 0; s < sites.length; s++) {
                                    if(s == 0){
                                        site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                    } else {
                                        site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                    }
                                }
                            }
                            doc.text(450,20,site_text,"right");
                        }
                        doc.text(15,25,"For the Period of " + from_header + " to " + to_header)

                        let colStyles = {}

                        colStyles = {
                            0: {cellWidth: 'auto',halign: 'center'},
                            1: {cellWidth: 'auto',halign: 'center'},
                            2: {cellWidth: 'auto',halign: 'left'},
                            3: {cellWidth: 'auto',halign: 'center'},
                            4: {cellWidth: 'auto',halign: 'center'},
                            5: {cellWidth: 'auto',halign: 'center'},
                            6: {cellWidth: 30,halign: 'center'},
                            7: {cellWidth: 'auto',halign: 'left'},
                            8: {cellWidth: 'auto',halign: 'center'},
                            9: {cellWidth: 'auto',halign: 'center'},
                            10: {cellWidth: 'auto',halign: 'center'},
                            11: {cellWidth: 'auto'},
                            12: {cellWidth: 'auto'},
                            13: {cellWidth: 'auto'},
                            14: {cellWidth: 'auto'},
                            15: {cellWidth: 'auto'},
                            16: {cellWidth: 'auto'},
                            17: {cellWidth: 'auto'},
                            18: {cellWidth: 'auto'},                            
                        }

                        doc.autoTable({
                            startY: 35,
                            head: headers,
                            body: reportData,
                            theme: 'plain',
                            tableWidth: 'wrap',
                            headStyles: {
                                lineWidth: 0.15,
                                cellPadding: 2
                            },
                            margin: {bottom: 25},
                            styles: {
                                cellPadding: 1.0, fontSize: 10,
                                halign: 'right'
                            },
                            columnStyles: colStyles,
                            didParseCell: function(data) {
                                if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                    data.cell.styles.fillColor = [0, 0, 0]
                                    data.cell.styles.fontSize = 1
                                    data.cell.styles.cellPadding = 0
                                } else if (data.row.section == 'body' && (data.row.raw[6] == 'Grand Total :' || data.row.raw[7] == 'Grand Total :')){
                                    data.cell.styles.fontStyle = 'bold'
                                }
                            }
                        });

                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        let pageCount = doc.internal.getNumberOfPages();

                        for(let i = 1; i <= pageCount; i++) {
                            doc.setPage(i);
                            reportUtils.pdfTools.addFooter(doc, printed_by, "Detailed Discount Reports" + group_text, design_x + 120, design_y + 135, i, pageCount)
                        }

                        
                    }
                    window.open(URL.createObjectURL(doc.output("blob")))
                    // doc.save(`DetailedDiscountReports_${moment().format('YYYYMMDDHHmmss')}.pdf`);
                } else {
                    reportUtils.openNotificationWithIcon(component_x, 'warning', 'Try increasing the scope by adjusting the filters.');
                }
                this.spinning= false;
            },
            getBase64Image(url) {
                const img = new Image();
                img.setAttribute('crossOrigin', 'anonymous');
                img.onload = () => {
                    const canvas = document.createElement("canvas");
                    canvas.width = img.width;
                    canvas.height = img.height;
                    const ctx = canvas.getContext("2d");
                    ctx.drawImage(img, 0, 0);
                    const dataURL = canvas.toDataURL("image/png");
                }
                return img.src = url
            },
            async generateExcel(){
                const workbook = new ExcelJS.Workbook();
                workbook.created = new Date();
                workbook.modified = new Date();
                const sheet = workbook.addWorksheet("Detailed Discount Report", {
                    pageSetup:{paperSize: 9}
                });

                let {from_date, to_date, from_header, to_header} = reportUtils.buildFromToHeaders(component_x, this.inputGroupBy, this.inputDate)
                let {filter_header, additional_params, status_header} = reportUtils.advanceFilterTools.buildAdditionalParams(this.params,this.advancedFilterParams, this.inputLocation)
                const data_starts_at_row = 8

                let reportLogo = document.getElementById('reportLogo');
            
                const base64Image = reportUtils.csvxlsxTools.getBase64Image(reportLogo)

                const imageId2 = workbook.addImage({
                    base64: base64Image,
                    extension: 'png',
                });

                sheet.addImage(imageId2, {
                    tl: { col: 0, row: 0 },
                    ext: { width: 61, height: 61 }
                });

                sheet.getRow(4).values = ["Detailed Discount Report"]
                sheet.getRow(5).values = [`For the Period of ${from_header} to ${to_header}`]
                sheet.getRow(6).values = [`Filtered by: ${status_header}${filter_header}}`]

                //custom header
                let header_arr = []
                header_arr.push("Date", "Trans Id", "Site", "Terminal Id",
                    "SI #", "Product Code", "Barcode", "Description", "Quantity",
                    "Discount Rate", "Approver", "Promo", "Manual Discount",
                    "SC", "PWD", "Total Discount", "SRP", "Subtotal", "Vatable Sales"
                )

                let row_arr = []
                row_arr.push(
                    { key: "document_date", width: 35 },
                    { key: "trans_id", width: 25 },
                    { key: "site_name", width: 35 },
                    { key: "terminal_id", width: 30 },
                    { key: "invoice_no", width: 30 },
                    { key: "product_code", width: 40 },
                    { key: "barcode", width: 30 },
                    { key: "description", width: 70 },
                    { key: "quantity", width: 15 },
                    { key: "discount_rate", width: 25 },
                    { key: "approver", width: 20 },
                    { key: "promo_price", width: 25 },
                    { key: "manual_discount", width: 25 },
                    { key: "senior_discount", width: 25 },
                    { key: "pwd_discount", width: 25 },
                    { key: "overall_discount", width: 25 },
                    { key: "price", width: 35 },
                    { key: "total_amount", width: 35 },
                    { key: "vat_sales", width: 35 },
                )

                sheet.getRow(data_starts_at_row).values = header_arr;
                sheet.columns = row_arr;

                var report_details = this.JsonData
                var rowDatas = []
                var horizontal_range = 0
                for(let i = 0; i < report_details.length; i++){
                    const report_detail = report_details[i]
                        if(report_detail){
                        let rowData = {
                            document_date: report_detail["Date"], 
                            trans_id: report_detail["Trans Id"],
                            site_name: report_detail["Site"],
                            terminal_id: report_detail["Terminal Id"],
                            invoice_no: report_detail["SI #"],
                            product_code: report_detail["Product Code"],
                            barcode: report_detail["Barcode"],
                            description: report_detail["Description"],
                            quantity: report_detail["Quantity"],
                            discount_rate: report_detail["Discount Rate"],
                            approver: report_detail["Approver"],
                            promo_price: report_detail["Promo"],
                            manual_discount: report_detail["Manual Discount"],
                            senior_discount: report_detail["SC"],
                            pwd_discount: report_detail["PWD"],
                            overall_discount: report_detail["Total Discount"],
                            price: report_detail["SRP"],
                            total_amount: report_detail["Subtotal"],
                            vat_sales: report_detail["Vatable Sales"]
                        }
                        

                            Object.assign(rowData);
                            rowDatas.push(rowData)
                        }
                    }

                sheet.addRows(rowDatas);

                //styles
                sheet.getRow(4).font = { bold: true, size: 16 };
                sheet.getRow(4).height = 20;
                sheet.getRow(data_starts_at_row).font = { bold: true };
                sheet.eachRow(function (Row, rowNum) {
                    if(rowNum >= data_starts_at_row){
                        Row.eachCell(function (Cell, cellNum) {
                            if (rowNum == data_starts_at_row) {
                                Cell.alignment = {
                                    horizontal: 'center'
                                }
                            }
                            else{
                                Cell.alignment = {
                                    vertical: 'middle',
                                    horizontal: 'left'
                                }
                            }
                        })
                    }
                })
                
                workbook.xlsx.writeBuffer().then(function(buffer) {
                    const blob = new Blob([buffer], { type: "applicationi/xlsx" });
                    saveAs(blob, `detailedDiscountReport.xlsx`);
                });
                this.JsonData = []
            },
            generateFile: async function() {
                this.spinning = true;
                let {from_date, to_date, from_header, to_header} = reportUtils.buildFromToHeaders(component_x, this.inputGroupBy, this.inputDate)
                let {filter_header, additional_params, status_header} = reportUtils.advanceFilterTools.buildAdditionalParams(this.params,this.advancedFilterParams, this.inputLocation)
                let parameters = {
                    "site_id": this.inputSite.toString(),
                    "date_from": from_date,
                    "date_to": to_date,
                    "group": this.inputGroupBy,
                    "isShow": this.isShowDetail,
                    "order": this.inputSortBy,
                    "by": this.showSortInfo,
                    "top": this.inputShowTop,
                    "isSeparate": this.isSeparateSite,
                    ...((this.inputLocation.length > 0) && {"location_path": this.inputLocation.toString()}),
                    "advanced_filter": this.params
                }

                var get_request = await HTTPRequest.getRequest(this.endPoint + 'detailed_discount_reports?', parameters);
                if(get_request.error) {
                    reportUtils.openNotificationWithIcon(component_x, 'error', get_request.error);
                    return
                }

                if(get_request.length > 0){
                    let siteSpecific = get_request;
                    let headers = ["Date", "Trans Id", "Site", "Terminal Id",
                    "SI #", "Product Code", "Barcode", "Description", "Quantity",
                    "Discount Rate", "Approver", "Promo", "Manual Discount",
                    "SC", "PWD", "Total Discount", "SRP", "Subtotal", "Vatable Sales"]

                    let site_specific = [];

                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details

                        let reportData = [];
                        if(x > 0){
                            // Add second set of headers
                            reportData.push(headers)
                        }

                        if(this.birSalesReports.length > 0){
                            let total_qty = 0
                            let total_total_amount = 0
                            let total_gross_price = 0
                            let total_amount_without_tax = 0
                            let total_salesman_comm = 0

                            let grand_qty = 0
                            let grand_total_amount = 0
                            let grand_gross_price = 0
                            let grand_total_amount_without_tax = 0
                            let grand_salesman_comm = 0

                            let grouper = 'start'
                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                let grouper_name = reportLine.grouper_name

                                if(grouper == 'start'){
                                    let detail_header = [grouper_name];
                                    reportData.push(Object.assign({}, detail_header))
                                } else {
                                    if(grouper != reportLine.grouper_id){
                                        let detail_header = [grouper_name];
                                        reportData.push(Object.assign({}, detail_header))
                                    }
                                }
                                grouper = reportLine.grouper_id

                                let detail = []
                                detail = [
                                    reportLine.document_date,
                                    reportLine.trans_id,
                                    reportLine.site_name,
                                    reportLine.terminal_id,
                                    reportLine.invoice_no,
                                    reportLine.product_code,
                                    reportLine.barcode,
                                    reportLine.description,
                                    this.convertToCurrency(Number(reportLine.quantity)),
                                    reportLine.discount_rate,
                                    reportLine.approver,
                                    this.convertToCurrency(Number(reportLine.promo_price)),
                                    this.convertToCurrency(Number(reportLine.manual_discount)),
                                    this.convertToCurrency(Number(reportLine.senior_discount)),
                                    this.convertToCurrency(Number(reportLine.pwd_discount)),
                                    this.convertToCurrency(Number(reportLine.overall_discount)),
                                    this.convertToCurrency(Number(reportLine.price)),
                                    this.convertToCurrency(Number(reportLine.total_amount)),
                                    this.convertToCurrency(Number(reportLine.vat_sales))
                                ];
                                
                                total_qty += Number(reportLine.quantity)
                                total_total_amount += Number(reportLine.total_amount)
                            
                                grand_qty += Number(reportLine.quantity)
                                grand_total_amount += Number(reportLine.total_amount)
                            
                                reportData.push(Object.assign({}, detail))

                                let sub_detail = []
                                let grand_detail = []
                                if(i == this.birSalesReports.length-1){
                                    //Subtotal
                                    sub_detail = ["", "", "","","",""]
                                    grand_detail = ["", "", "","","",""]

                                    
                                    sub_detail.push('Sub Total :', '',
                                        this.convertToCurrency(total_qty), '','','','','','','',
                                        this.convertToCurrency(total_total_amount)
                                    );

                                    reportData.push(Object.assign({}, sub_detail))

                                    //Grand Total
                                    grand_detail.push('Grand Total :', '',
                                            this.convertToCurrency(grand_qty),'','','','','','','',
                                            this.convertToCurrency(grand_total_amount),
                                    );

                                    reportData.push(Object.assign({}, grand_detail));
                                } else {
                                    let current_grouper = ""
                                    let next_grouper = ""

                                    current_grouper = reportLine.grouper_id
                                    next_grouper = this.birSalesReports[i+1].grouper_id

                                    if(current_grouper != next_grouper){
                                        
                                        sub_detail = ["", "", "","","",""]

                                        sub_detail.push('Sub Total :', '',
                                            this.convertToCurrency(total_qty), '','','','','','','',
                                            this.convertToCurrency(total_total_amount)
                                        );

                                        reportData.push(Object.assign({}, sub_detail))

                                        total_qty = 0
                                        total_total_amount = 0
                                    }
                                }
                            }

                        }

                        let group_text = ""
                        if(this.inputGroupBy != ''){
                            group_text = " by " + this.sortOptions[0].value
                        }

                        if(this.isSeparateSite == true){
                            reportData.unshift([siteSpecific[x].report_details[0].site_name]);
                        } else {
                            let site_text = ''
                            if(this.inputSite.length == 0){
                                site_text = 'All Sites'
                            } else {
                                let sites = this.inputSite
                                for (var s = 0; s < sites.length; s++) {
                                    if(s == 0){
                                        site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                    } else {
                                        site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                    }
                                }
                            }
                            reportData.unshift([site_text]);
                        }
                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        reportData.push(["Detailed Discount Report" + group_text, "Generated By: " + printed_by,"For the Period of " + from_header + " to " + to_header])
                        reportData.push([])

                        let keys = headers;
                        let values = reportData;
                        var values_length = values.length;

                        let newJsonData=[];

                        // change headers and report data as key and value object
                        for(var i=0;i < values_length; i++){
                            var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                                [val]: values[i][index]
                                    }
                                )
                            )
                            );
                            newJsonData.push(result)
                        }

                        // change undefined on arr
                        newJsonData.forEach(function(obj) {
                            for(var i in obj) {
                            if(obj[i] === undefined || obj[i] === null ) {
                                obj[i] = '';
                            }
                            }
                        });
                        site_specific.push(newJsonData)
                    }
                    // for each site specific[] convert nested to single array
                    this.JsonData = site_specific.flat(Infinity);
                } else {
                    reportUtils.openNotificationWithIcon(component_x, 'warning', 'Try increasing the scope by adjusting the filters.');
                }
                this.spinning = false;
            },
            clearJsonData(){
                this.JsonData = [];
            },
            addMaskValidation(value){
                if(!this.accessRights.includes('Z')){
                    return value.substring(0,value.length).replace(/\d/g,"*")
                }else{
                    return value
                }
            }
        }
    };
    </script>

    <style></style>
